import {LoginButtonColor, LoginButtonSize} from '@logistics-frontend/blocks'
import {HeaderDesktop, HeaderRu} from '@logistics-frontend/order-layout-blocks'
import React, {memo} from 'react'

import {User} from 'src/shared/components/desktop'
import {appConfig} from 'src/shared/config'

import {DEFAULT_TLD} from '../defaults'
import {controlPanel, linksList} from './country-consts'
import {getCountryButton} from './utils'

const {tld = 'ru'} = appConfig

const safeControlPanel = controlPanel[tld] || controlPanel[DEFAULT_TLD]
const controlPanelData = [...safeControlPanel, getCountryButton()]
const linksListData = linksList[tld] || linksList[DEFAULT_TLD]

export const Header = memo(function Header(): React.ReactElement {
  if (tld === 'ru') {
    return <HeaderRu user={<User color={LoginButtonColor.DARK} size={LoginButtonSize.S} />} />
  }
  return <HeaderDesktop controlPanelData={controlPanelData} linksList={linksListData} user={<User />} />
})
